import API from 'utils/api';
import getFormattedValues, { hasFiles } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/catalogos/tarifa-isr';

const getValuesAndConfig = (values) => {
  const files = ['foto', 'firma_electronica'];
  const config = hasFiles(values, files) ? {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  } : {};
  const formattedValues = getFormattedValues(values, {
    files,
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * GET TarifaISR
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getTarifasISR = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET TarifaISR
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getTarifaISR = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST TarifaISR
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTarifaISR = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH TarifaISR
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTarifaISR = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE TarifaISR
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteTarifaISR = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST clonar TarifaISR (duplica la tarifa y su detalle)
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const clonarTarifaISR = async (id) => {
  try {
    const response = await API.post(`${baseURI}/${id}/clonar`);
    onSuccess(response, 'Tarifa ISR clonada correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
